import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Workflow_Events extends PureComponent {
  render() {
    return (
      <div className="row" id="workflow_events">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Workflow Events</h2>
              <p>
                Workflow events are events stored in the Settings - Workflow
                part of the Nexoid Application. These can be created by an
                administrator or automatically created when you install a model.{" "}
              </p>

              <p>
                Workflow events and run at the backend, so are great for hiding
                more sensitive data and processing from your users. For a
                workflow event to work, it will need to be assigned a user (the
                account in which will run the code) and a trigger (the event
                that causes the code to run).
              </p>

              <p>
                There are three ways triggers for workflow events; scheduled
                tasks, Inbound API calls and record events. Scheduled events are
                great for maintenance and outbound reporting. Inbound API
                workflows are useful when integrating third-party systems to
                Nexoid and record events are useful for integrating Nexoid to
                third-party systems.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="hidden-sm-xs col-md-6 darkCol ">
          <div className="contentDark"></div>
        </div>
      </div>
    );
  }
}

export default Workflow_Events;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/Workflow_Events.js